import { render, staticRenderFns } from "./newProductStatistics.vue?vue&type=template&id=fdbe912a&scoped=true&"
import script from "./newProductStatistics.vue?vue&type=script&lang=js&"
export * from "./newProductStatistics.vue?vue&type=script&lang=js&"
import style0 from "./newProductStatistics.vue?vue&type=style&index=0&id=fdbe912a&prod&lang=stylus&scoped=true&"
import style1 from "./newProductStatistics.vue?vue&type=style&index=1&id=fdbe912a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbe912a",
  null
  
)

export default component.exports